import React from 'react';
import Info from '../../../src/front/Businesses/Info';
import AuthDialogContextProvider from '../../../src/front/components/AuthDialog/AuthDialogContextProvider';

const BusinessInfo = (props) => (
  <AuthDialogContextProvider isLoggedIn={props.authenticated}>
    <Info {...props} loaded />
  </AuthDialogContextProvider>
);

export default BusinessInfo;
